"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreatmentPlanNoteType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var TreatmentPlanNoteType_Factory = /** @class */ (function () {
    function TreatmentPlanNoteType_Factory() {
    }
    TreatmentPlanNoteType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    TreatmentPlanNoteType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return TreatmentPlanNoteType_Factory;
}());
exports.TreatmentPlanNoteType_Factory = TreatmentPlanNoteType_Factory;
